import { Skeleton } from "antd";
import React from "react";

const AllCarbonCreditsLoader = ({ numberOfSkeletons = 8 }) => {
    const renderSkeletons = () => {
        return Array.from({ length: numberOfSkeletons }, (_, index) => (
            <div
                key={index}
                className=" flex bg-white p-2 rounded-lg  mb-2"
            >
                <Skeleton.Image active={true} className=" w-full h-8" />
                <div className=" justify-between py-2">
                    <div className="">
                        <Skeleton.Button active={true} />
                        <Skeleton.Avatar active={true} />
                    </div>
                    <Skeleton.Button block={true} active={true} />
                </div>
            </div>
        ));
    };

    return <>{renderSkeletons()}</>;
};

export default AllCarbonCreditsLoader;
